import { DataLast30Days } from 'Consts/types';

import * as api from 'Api/endpoints';

import type { RootState, Action } from 'State/store';
import { createStandardSlice } from 'State/utils';

const slice = createStandardSlice<DataLast30Days>('employeeMonthlyDataUsage');

const fetchData = (): Action => {
  return async (dispatch, getState) => {
    const { activeLocation } = getState().locations;
    const customerId = activeLocation?.customerId;
    const { data: token } = getState().locations.activeLocation
      ?.accessedAsCoAdminLocation
      ? getState().auth.coAdminData
      : getState().auth.data;
    const cloud = getState().auth.cloud;
    const employeeMonthlyDataUsage = getState().dataUsage.employee.monthly;

    if (
      employeeMonthlyDataUsage.isLoading ||
      !customerId ||
      !token ||
      !activeLocation?.id
    ) {
      return;
    }

    dispatch(actions.isLoading(true));

    const { data, error } =
      await api.getEmployeeNetworkMonthlyDataUsageCategories({
        customerId,
        locationId: activeLocation.id,
        token,
        cloud,
      });

    if (error || !data) {
      dispatch(actions.error(error?.message || 'Error fetching data usage'));

      return;
    }

    dispatch(actions.set(data.last30Days));
  };
};

export const selectors = (state: RootState) => state.dataUsage.employee.monthly;

export const actions = {
  ...slice.actions,
  fetchData,
};

export default slice.reducer;
